var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDebtors = function SvgDebtors(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C0C5D2",
    d: "M11 20.9V24h2v-3.1c4.2-.5 7.5-3.8 7.9-7.9H24v-2h-3.1c-.5-4.2-3.8-7.5-7.9-7.9V0h-2v3.1c-4.2.5-7.5 3.8-7.9 7.9H0v2h3.1c.4 4.2 3.7 7.5 7.9 7.9M12 5c3.9 0 7 3.1 7 7s-3.1 7-7 7-7-3.1-7-7 3.1-7 7-7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#C0C5D2",
    d: "M12 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6M12 17.4c2.1 0 3.9-1.2 4.8-3-.6-.3-1.2-.5-1.8-.5H9c-.7 0-1.3.2-1.8.5.9 1.8 2.7 3 4.8 3"
  })));
};
export default SvgDebtors;